import styled from 'styled-components';
import { color, font, media } from 'style';
import { Heading } from 'components';

export default {
  Headings: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
    text-align: center;
  `,
  Heading: styled(Heading)`
    max-width: 610px;
  `,
  SubHeading: styled.div`
    font-size: ${font.size.large};
    margin-top: 10px;
  `,
  Content: styled.div`
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    gap: 30px;

    ${media.lg`
      gap: 60px;
    `}
  `,
  BenefitContainer: styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
  `,
  ImageContainer: styled.div`
    display: none;

    ${media.lg`
      display: flex;
      flex: 0 1 35%;
      display: flex;
      justify-content: center;
    `}
  `,
  Image: styled.img<{ width: number }>`
    width: 100%;
    max-width: ${({ width }) => width}px;
  `,
  BulletItem: styled.div`
    display: flex;
    padding: 15px;
    align-items: start;
    box-sizing: border-box;

    ${media.lg`
      flex: 1 2 65%;
    `}
  `,
  BulletText: styled.p`
    all: unset;
    width: 100%;
    max-width: 670px;
    line-height: 25px;
  `,
  OrderIndicator: styled.div`
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;
    border-radius: 50%;
    color: ${color.white};
    background-color: ${color.hmPurple4};
    line-height: 50px;
    text-align: center;
    margin-right: 20px;
    font-size: ${font.size.xxLarge};
  `,
  Footer: styled.div`
    margin-top: 50px;
    text-align: center;
    line-height: 25px;
  `,
};
